module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('company-form-blank', _vm._b({
    attrs: {
      "submit-label": "Сохранить",
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.processCompanyForm
    }
  }, 'company-form-blank', _vm.$attrs, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3dd6e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/company/CompanyEditForm.vue
// module id = 727
// module chunks = 0